export enum PayloadStates {
  UNSET = 'unset',
  SAVING = 'saving',
  SAVED = 'saved',
  FAILED = 'failed',
}
